/* eslint-disable no-console */
import Vue from 'vue'
// import { rebuildSocket } from '~/helpers/RebuildSocket';
import {
  groupEditService,
  groupGetService,
  groupPostService,
  memberAddGroup,
  memberDropGroup,
  membersGetService,
  messageDeleteService,
  messageEditService,
  messageGetService,
  messagePostService,
  messageReadService,
  messageSpamService,
} from '@/store/chat/chat-api'

const state = () => ({
  activeDialog: null,
  groups: [],
  messages: [],
  members: [],
  editable: {
    id: null,
    content: null,
  },
  socket: {
    error: null,
    isConnected: false,
    reconnectError: false,
  },
})

const getters = {
  activeDialog: (state) => state.activeDialog,
  messages: (state) => state.messages,
  groups: (state) => state.groups,
  groupsSearch: (state) => (search) => {
    const groups = state.groups
    const searchStr = search.trim().toLowerCase()
    if (groups && groups.length) {
      return groups
        .filter((x) => {
          const matchedTitle = x.title && x.title.trim().toLowerCase().indexOf(searchStr) !== -1
          const matchedMessage =
            x.message && x.message.content && x.message.content.trim().toLowerCase().indexOf(searchStr) !== -1

          return matchedTitle || matchedMessage
        })
        .sort((a, b) => {
          const from = b.message ? b.message.created_at : b.created_at
          const to = a.message ? a.message.created_at : a.created_at

          return from - to
        })
    }

    return []
  },
  members: (state) =>
    state.members.sort((a, b) => {
      var nameA = (a.localized_name.en ? a.localized_name.en : a.first_name || '').toUpperCase()
      var nameB = (b.localized_name.en ? b.localized_name.en : b.first_name || '').toUpperCase()

      return nameA < nameB ? -1 : nameA > nameB ? 1 : 0
    }),
  membersGrouped: (_state, getters) => {
    let groupkeys = getters.members.map((x) => (x.localized_name.en ? x.localized_name.en : x.first_name ?? 'Unknown').split('')[0].toUpperCase())
    groupkeys = [...new Set(groupkeys)]

    return groupkeys.map((key) => {
      return {
        key,
        list: getters.members.filter((x) => (x.localized_name.en ? x.localized_name.en : x.first_name ?? 'Unknown').split('')[0].toUpperCase() === key),
      }
    })
  },
  membersGroupedSearch: (_state, getters) => (search) => {
    const members = getters.membersGrouped
    const searchStr = search.trim().toLowerCase()

    if (members && members.length) {
      const mapped = members.map((group) => {
        return {
          key: group.key,
          list: group.list.filter((m) => {
            return (m.localized_name.en ? m.localized_name.en : m.first_name) && (m.localized_name.en ? m.localized_name.en : m.first_name).toLowerCase().indexOf(searchStr) !== -1
          }),
        }
      })

      return mapped.filter((x) => x.list && x.list.length)
    }

    return []
  },
  headActive: (state) => {
    let head = {
      title: 'user name user name',
      online: false,
      type: null,
      members: [],
    }

    const dialog = state.groups.find((x) => x.id === state.activeDialog)

    if (dialog) {
      const {
        id,
        title,
        members,
        type: { id: type_id },
        author: { first_name, last_name, online },
      } = dialog

      head.id = id
      head.type = type_id
      head.title = title
      head.online = online
      head.members = members

      if (dialog.type?.id === 2 && members[1]) {
        const { first_name, last_name } = members[1]
        head.title = `${first_name} ${last_name}`
      }

      if ([1, 3].includes(type_id)) {
        head.title = title
      }
    }

    return head
  },
  socket: (state) => state.socket,
  isConnected: (state) => state.socket.isConnected,
  editable: (state) => state.editable,
}

const mutations = {
  SOCKET_ONOPEN(state, event) {
    state.socket.isConnected = true
    state.socket.error = null
    state.socket.reconnectError = false
  },
  // SOCKET_ONCLOSE(state, event) {
  //   console.log('SOCKET_ONCLOSE', event)
  //   state.socket.isConnected = false
  // },
  // SOCKET_ONERROR(state, event) {
  //   // console.error('SOCKET_ONERROR', event);
  //   state.socket.error = event
  // },
  // SOCKET_ONMESSAGE(state, message) {
  //   console.log('SOCKET_ONMESSAGE', message)
  //   const { event, data, meta, exception } = message

  //   switch (event) {
  //     case EVENTS.MESSAGES:
  //       if (meta.offset === 0) {
  //         state.messages = data
  //       } else {
  //         state.messages = [...data, ...state.messages]
  //       }

  //       state.messagesMeta = meta
  //       break

  //     default:
  //       break
  //   }
  // },
  // SOCKET_RECONNECT(state, count) {
  //   console.info(state, count)
  // },
  // SOCKET_RECONNECT_ERROR(state) {
  //   state.socket.reconnectError = true
  // },

  // Static (inner) mutations
  setActiveDialog(state, id) {
    if(id !== state.activeDialog) {
      state.messages = []
      state.activeDialog = id
    }
    const groupIndex = state.groups.findIndex((item) => item.id === id);
    if(~groupIndex) {
      Vue.set(state.groups[groupIndex], 'message_read', state.groups[groupIndex].message_count);
    }
  },
  setMembers(state, payload) {
    state.members = payload
  },
  setMembersOnline(state, ids) {
    state.members = state.members.map((m) => {
      return {
        ...m,
        online: ids.includes(m.id),
      }
    })
  },
  setGroups(state, payload) {
    state.groups = payload
  },
  addGroup(state, payload) {
    const currentList = state.groups || []
    state.groups = [...currentList, payload]
  },
  deleteGroup(state, payload) {
    state.groups = state.groups.filter((item) => item.id != payload.id);
  },
  updateGroup(state, payload) {
    state.groups = [...state.groups.map((x) => (x.id !== payload.id ? x : payload))]
  },
  setMessages(state, payload) {
    state.messages = payload
  },
  addMessage(state, payload) {
    state.messages = [...state.messages, payload]
  },
  updateMessage(state, payload) {
    state.messages = [...state.messages.map((x) => (x.id !== payload.id ? x : payload))]
  },
  deleteMessageById(state, id) {
    state.messages = state.messages.filter((x) => x.id !== id)
  },
  resetMessages(state) {
    state.activeDialog = null
    state.messages = []
  },
  resetOnLogout(state) {
    state.activeDialog = null
    state.messages = []
    state.dialog = []
    state.reply = {
      id: null,
      text: null,
    }
  },
  setEditable(state, req) {
    state.editable.id = req.id
    state.editable.content = req.content
  },
  // pushGhostMessage(state, message) {
  //   state.messages.push(message)
  // },
}

const actions = {
  socketMessage({ state, ...other }, payload) {
    // console.log('VUEX: socketMessage mutation', payload, payload.group.id, state.activeDialog)
    // adds to message array only when group matched (i.e. current dialog is opened)
    if (state.activeDialog === (payload.group && payload.group.id)) {
      const haveMessage = state.messages.length && state.messages.some((x) => x.id === payload.id)

      if (!haveMessage) {
        state.messages = [...state.messages, payload] // add
      } else {
        state.messages = [...state.messages.map((x) => (x.id !== payload.id ? x : payload))] // update
      }
    }

    const currentUserId = Vue.auth.user()?.id;
    // always update last_massege in dialogs list
    const groupIndex = state.groups.findIndex((g) => g.id === payload.group.id);
    if(~groupIndex) {
      const group = state.groups[groupIndex];
      if(group.message?.id !== payload.id) {
        if(payload.author.id != currentUserId)
          Vue.set(group, 'message_count', group.message_count + 1);
      }
      Vue.set(group, 'message', payload);
    }
  },

  // members actions
  async getMembers({ commit }, request) {
    const [err, result] = await membersGetService(request)

    if (err) throw err

    commit('setMembers', result.data)

    return result
  },
  async addMember({ commit, dispatch }, request) {
    const [err, result] = await memberAddGroup(request)

    if (err) throw err

    commit('updateGroup', result)

    return result
  },
  async dropMember({ commit, dispatch }, request) {
    const [err, result] = await memberDropGroup(request)

    if (err) throw err

    commit('updateGroup', result)

    return result
  },
  // group actions
  async getGroups({ commit }, request) {
    const [err, result] = await groupGetService(request)

    if (err) throw err

    commit('setGroups', result.data)

    return result
  },
  async createGroupP2P({ commit, dispatch }, user) {
    return dispatch('createGroup', { type: 2, title: 'p2p chat', members: [user?.id] }).then((res) => {
      commit('setActiveDialog', res.id)
      return res
    })
  },
  async createGroup({ commit, state }, request) {
    const [err, result] = await groupPostService(request)

    if (err) throw err

    if (state.groups && state.groups.some((x) => x.id === result.id)) {
      commit('updateGroup', result)
    } else {
      commit('addGroup', result)
    }

    return result
  },
  async updateGroup({ commit, state }, request) {
    const [err, result] = await groupEditService(request)

    if (err) throw err

    if (state.groups && state.groups.some((x) => x.id === result.id)) {
      commit('updateGroup', result)
    } else {
      commit('addGroup', result)
    }

    return result
  },
  // messages actions
  async getMessages({ commit }, request) {
    const [err, result] = await messageGetService(request)

    if (err) throw err

    commit('setMessages', result.data)

    return result
  },
  async createMessage({ commit }, request) {
    const [err, result] = await messagePostService(request, request.replyId)

    if (err) throw err

    commit('addMessage', result)

    return result
  },
  async uploadFile({ commit }, request) {
    const formData = new FormData()
    formData.append('upload', request.upload)
    formData.append('type', request.type)
    formData.append('group_id', request.group_id)
    if (request.content) {
      formData.append('content', request.content)
    }

    const [err, result] = await messagePostService(formData)

    if (err) throw err

    commit('addMessage', result)

    return result
  },
  async readMessage({ commit }, request) {
    const [err, result] = await messageReadService(request)

    if (err) throw err

    commit('updateMessage', result)

    return result
  },
  async editMessage({ commit }, request) {
    const [err, result] = await messageEditService(request)

    if (err) throw err

    commit('updateMessage', result)

    return result
  },
  async deleteMessage({ commit }, request) {
    const [err, result] = await messageDeleteService(request)

    if (err) throw err

    commit('deleteMessageById', result.id)

    return result
  },
  async spamMessage({ commit }, { id, state }) {

    const [err, result] = await messageSpamService(id, state)

    if (err) throw err

    commit('updateMessage', result)

    return result
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
